export default "__VITE_ASSET__38ef3944__"